export { SearchBoxWithRoundedCorners } from './SearchBoxWithRoundedCorners';
